var _style, _path, _g, _path2, _g2, _path3, _path4, _path5, _path6, _g3, _path7, _path8, _path9, _g4, _g5, _defs, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthiqunProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000038414886154458872420000007026086903406359959_);}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#FF725E;}\r\n\t.st4{fill:url(#SVGID_00000002363945854607024140000015945742502955846327_);}\r\n\t.st5{fill:url(#SVGID_00000046331804127690791070000004868808027930476963_);}\r\n\t.st6{fill:url(#SVGID_00000051363050773846814580000004458963126820740233_);}\r\n\t.st7{fill:url(#SVGID_00000091003879474626718430000005948161674468634525_);}\r\n\t.st8{fill:url(#Brazo_derecho_00000078732437488884220910000012036957703183863936_);}\r\n\t.st9{fill:url(#SVGID_00000112629197564648638120000012431357323280709566_);}\r\n\t.st10{fill:#D7E1EF;}\r\n\t.st11{opacity:0.15;fill:#FFFFFF;}\r\n\t.st12{opacity:0.95;fill:#476393;}\r\n\t.st13{fill:url(#SVGID_00000016041831211478228310000012296368990199928224_);}\r\n\t.st14{fill:#009CD7;}\r\n\t.st15{fill:url(#Antena_00000038395480069530119120000006831443862906846627_);}\r\n\t.st16{fill:url(#SVGID_00000108992250009976688840000016903051721248117891_);}\r\n\t.st17{fill:#476393;}\r\n\t.st18{fill:url(#SVGID_00000055671834181414131770000004955927600728470178_);}\r\n\t.st19{opacity:0.9;fill:#F3FCFF;}\r\n\t.st20{fill:url(#Brazo_Izquierdo_00000089549797333494650960000017716182155282027964_);}\r\n\t.st21{fill:url(#SVGID_00000081637720403469037510000000946181323578149273_);}\r\n\t\r\n\t\t.st22{clip-path:url(#SVGID_00000111872560335399009670000001144326636452161458_);fill:url(#SVGID_00000142869206648068792330000008500947463550729879_);}\r\n\t.st23{display:none;fill:url(#SVGID_00000150102953916115771580000017001743644955521158_);}\r\n\t.st24{fill:url(#SVGID_00000150093306759469098390000014328742729719247548_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.1379,
    y1: 400.2057,
    x2: 74.4318,
    y2: 333.8363,
    gradientTransform: "matrix(1 0 0 -1 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3392,
    style: {
      stopColor: "#CCE5E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9067,
    style: {
      stopColor: "#33958C"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.6,170.9c18.8-27.3,50.2-45.3,85.8-45.3c36,0,67.7,18.4,86.4,46.2l44.4-22.6 c-27.1-43.9-75.6-73.3-130.9-73.3c-54.1,0-101.8,28.1-129.1,70.5L128.6,170.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111885520645330650390000008095561933885096361_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.365,
    y1: 152.953,
    x2: 292.6234,
    y2: 330.3763,
    gradientTransform: "matrix(1 0 0 -1 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3392,
    style: {
      stopColor: "#99CAC5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9067,
    style: {
      stopColor: "#CCE5E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111885520645330650390000008095561933885096361_)"
    },
    d: "M262,322h75c19.4-25.7,31-57.7,31-92.4 c0-25.8-6.4-50.1-17.7-71.5L306,180.6c7.8,14.6,12.3,31.3,12.3,49C318.3,269.8,295.4,304.7,262,322z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M354.6,311.5c0,1.8,1.5,3.3,3.3,3.3s3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3S354.6,309.7,354.6,311.5z"
  })))), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M84.4,333.6H22.2c-3.2,0-5.8,2.6-5.8,5.8v38c0,3.2,2.6,5.8,5.8,5.8h134.1C128,373.5,103.2,356.2,84.4,333.6z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054970724148677881500000002934832326857716112_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.6312,
    y1: 102.8262,
    x2: 119.5937,
    y2: 154.739,
    gradientTransform: "matrix(1 0 0 -1 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6008,
    style: {
      stopColor: "#66B0A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#99CAC5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054970724148677881500000002934832326857716112_)"
    },
    d: "M84.4,333.6H22.2 c-3.2,0-5.8,2.6-5.8,5.8v38c0,3.2,2.6,5.8,5.8,5.8h134.1C128,373.5,103.2,356.2,84.4,333.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1_00000060750584691589456730000004926298570186450576_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078033701045623811960000012857495257854604989_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.1379,
    y1: 400.2057,
    x2: 74.4318,
    y2: 333.8363,
    gradientTransform: "matrix(1 0 0 -1 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3392,
    style: {
      stopColor: "#44CB67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9067,
    style: {
      stopColor: "#FFAF00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078033701045623811960000012857495257854604989_)"
    },
    d: "M128.6,170.9 c18.8-27.3,50.2-45.3,85.8-45.3c36,0,67.7,18.4,86.4,46.2l44.4-22.6c-27.1-43.9-75.6-73.3-130.9-73.3 c-54.1,0-101.8,28.1-129.1,70.5L128.6,170.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125598861171366131780000002390518055903874746_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.365,
    y1: 152.953,
    x2: 292.6234,
    y2: 330.3763,
    gradientTransform: "matrix(1 0 0 -1 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1269,
    style: {
      stopColor: "#7C4DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9067,
    style: {
      stopColor: "#44CB67"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125598861171366131780000002390518055903874746_)"
    },
    d: "M262,322h75c19.4-25.7,31-57.7,31-92.4 c0-25.8-6.4-50.1-17.7-71.5L306,180.6c7.8,14.6,12.3,31.3,12.3,49C318.3,269.8,295.4,304.7,262,322z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M354.6,311.5c0,1.8,1.5,3.3,3.3,3.3s3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3S354.6,309.7,354.6,311.5z"
  })))), /*#__PURE__*/React.createElement("g", null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M84.4,333.6H22.2c-3.2,0-5.8,2.6-5.8,5.8v38c0,3.2,2.6,5.8,5.8,5.8h134.1C128,373.5,103.2,356.2,84.4,333.6z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086679620272387099910000014009838207347746961_",
    gradientUnits: "userSpaceOnUse",
    x1: -2.6312,
    y1: 102.8262,
    x2: 119.5937,
    y2: 154.739,
    gradientTransform: "matrix(1 0 0 -1 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6008,
    style: {
      stopColor: "#3180FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7C4DFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086679620272387099910000014009838207347746961_)"
    },
    d: "M84.4,333.6H22.2 c-3.2,0-5.8,2.6-5.8,5.8v38c0,3.2,2.6,5.8,5.8,5.8h134.1C128,373.5,103.2,356.2,84.4,333.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Robot_bectores"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Brazo_derecho_00000171704231542358112860000016495288787171679104_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.8944,
    y1: 1005.8196,
    x2: 396.3315,
    y2: 947.0206,
    gradientTransform: "matrix(0.6676 0.8402 1.0469 -0.761 -1042.9441 714.6307)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7E1EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFC8D6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Brazo_derecho",
    style: {
      fill: "url(#Brazo_derecho_00000171704231542358112860000016495288787171679104_)"
    },
    d: " M231.6,311.5c22.3,14.8,24.2,20.8,33.5,19.5c1.1-0.1,6.6-0.9,11.2-4.9c3.7-3.2,5.3-7.2,5.8-9.2c2.8-12.6-17.6-25.2-41.2-26.7 c-4.2-0.3-15.5-2.2-19,2.4c-1.4,1.9-1.1,4.1-0.8,5.7C222.2,305.4,228.2,309.2,231.6,311.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154426104257541901230000003106822289805013913_",
    gradientUnits: "userSpaceOnUse",
    x1: 265.995,
    y1: 323.0533,
    x2: 269.7267,
    y2: 325.6892,
    gradientTransform: "matrix(0.8168 -0.5769 0.5769 0.8168 -137.8629 196.765)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BFC8D6",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1051,
    style: {
      stopColor: "#D2D8E2",
      stopOpacity: 0.1051
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2591,
    style: {
      stopColor: "#E6E9EF",
      stopOpacity: 0.2591
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    style: {
      stopColor: "#F4F6F8",
      stopOpacity: 0.4343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6467,
    style: {
      stopColor: "#FCFDFD",
      stopOpacity: 0.6467
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154426104257541901230000003106822289805013913_)"
    },
    d: "M269.7,299c-1.3,2.7-2.3,5.5-3.1,8.4 c-0.7,2.9-1,5.5-0.9,7.9c0,0.2,0.2,0.3,0.3,0.3c0.2,0,0.3-0.2,0.3-0.3c-0.2-2.4,0.1-4.9,0.8-7.7c0.7-2.8,1.7-5.6,3-8.2 c0.1-0.2,0-0.3-0.2-0.4c-0.1-0.1-0.2,0-0.3,0C269.8,298.9,269.8,298.9,269.7,299"
  })), /*#__PURE__*/React.createElement("g", null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Cuerpo",
    className: "st10",
    d: "M182.5,292.2c3.7-3.1,8.1-5.1,9.7-5.7c5.7-2.1,10.8-1.7,14.2-1.7h0.6c3.4,0,8.4-0.3,14.2,1.7 c1.6,0.6,6.8,1.9,9.7,5.7c11.8,15.6,17.7,58.6,17.7,58.6c-19.6,9.5-24,19.5-37.3,17.2l0-13.6h-8.8l0,13.6 c-16.2,1.5-17.2-10-36.4-17.2C166,350.8,170.7,302.2,182.5,292.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Circulo"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M223.8,311c1.9,12.1-7.9,22.5-19.4,20.5c-7-1.2-12.6-7.1-13.7-14.5c-1.9-12.1,7.9-22.5,19.4-20.5 C217.1,297.7,222.7,303.7,223.8,311z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M223.8,311.7c1.9,11.7-7.9,21.8-19.4,19.8c-7-1.2-12.6-6.9-13.7-14c-1.9-11.7,7.9-21.8,19.4-19.8 C217.1,298.9,222.7,304.6,223.8,311.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132067733134340922310000014221557445025272473_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.2591,
    y1: 298.555,
    x2: 207.2591,
    y2: 331.7873
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009CD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08943874,
    style: {
      stopColor: "#007DB9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2213,
    style: {
      stopColor: "#015794"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3586,
    style: {
      stopColor: "#013875"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5006,
    style: {
      stopColor: "#021F5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6494,
    style: {
      stopColor: "#020E4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8093,
    style: {
      stopColor: "#020342"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#02003F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132067733134340922310000014221557445025272473_)"
    },
    d: "M223.8,312.4 c1.9,11.4-7.9,21.1-19.4,19.2c-7-1.1-12.6-6.7-13.7-13.6c-1.9-11.4,7.9-21.1,19.4-19.2C217.1,299.9,222.7,305.5,223.8,312.4z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 207.1,
    cy: 314.7,
    rx: 11.9,
    ry: 12
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M207.2,322.5l-7.9-11.9l7.9,6.9l9.5-9.8c-2.2-3-5.7-5-9.7-5c-6.6,0-11.9,5.4-11.9,12 c0,6.6,5.3,12,11.9,12c6.6,0,11.9-5.4,11.9-12c0-2.1-0.6-4.1-1.5-5.8L207.2,322.5z M207.2,307.7c1.5,0,2.7,1.2,2.7,2.8 c0,1.5-1.2,2.8-2.7,2.8c-1.5,0-2.7-1.2-2.7-2.8C204.5,309,205.7,307.7,207.2,307.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M223.7,300.7l-6.9,7.1c0.3,0.4,0.5,0.7,0.7,1.1L223.7,300.7z"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M178.2,301.5c-0.2,0.1-0.2,0.3-0.1,0.4c0.1,0.2,0.3,0.2,0.4,0.1c9.3-5.1,18.6-7.6,27.9-7.6 s18.6,2.5,27.9,7.6c0.2,0.1,0.3,0,0.4-0.1c0.1-0.2,0-0.3-0.1-0.4c-9.4-5.1-18.8-7.7-28.2-7.7C197,293.7,187.6,296.3,178.2,301.5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Cabeza_1_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Antena_00000078763765026505825640000014137588654258465681_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.2512,
    y1: 131.602,
    x2: 207.2512,
    y2: 166.8977
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#99E9ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1983,
    style: {
      stopColor: "#7FCFF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5539,
    style: {
      stopColor: "#55A5F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8333,
    style: {
      stopColor: "#3B8BFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3181FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Antena",
    style: {
      fill: "url(#Antena_00000078763765026505825640000014137588654258465681_)"
    },
    d: "M220.5,144 c0,5.9-3.8,10.7-9,12.5l0,10l-8.8,0l0-10c-5.1-1.9-8.7-6.8-8.7-12.5c0-7.3,5.9-13.1,13.2-13.1C214.6,130.9,220.5,136.6,220.5,144z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013189654577840272910000012784210965159428996_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.2551,
    y1: 166.2811,
    x2: 207.2551,
    y2: 289.5784
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7E1EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    style: {
      stopColor: "#CEDAEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFCFE5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013189654577840272910000012784210965159428996_)"
    },
    d: "M207.3,166.3 c-38.7,0-70.1,31.4-70.1,70.1v13.1c0,22.2,18,40.1,40.1,40.1h59.9c22.2,0,40.1-18,40.1-40.1v-13.1 C277.3,197.7,246,166.3,207.3,166.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M149.4,249.4c0,13.7,11.1,24.8,24.8,24.8h66c13.7,0,24.8-11.1,24.8-24.8v-17.9c0-18.8-15.3-34.1-34.1-34.1 h-47.4c-18.8,0-34.1,15.3-34.1,34.1V249.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M149.4,232.8c0-18.9,15.4-34.3,34.3-34.3h47c18.9,0,34.3,15.4,34.3,34.3v17.5c0,13.8-11.2,25-25,25h-65.6 c-13.8,0-25-11.2-25-25L149.4,232.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035501885769247738930000007692428894727184793_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.2552,
    y1: 202.9049,
    x2: 207.2552,
    y2: 275.4541
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#013792"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#012B44"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035501885769247738930000007692428894727184793_)"
    },
    d: "M149.4,237.2 c0-18.9,15.4-34.3,34.3-34.3h47c18.9,0,34.3,15.4,34.3,34.3v13.3c0,13.8-11.2,25-25,25h-65.6c-13.8,0-25-11.2-25-25V237.2z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M235.7,251.1c0,3.6,3,6.6,6.6,6.6h1.6c3.6,0,6.6-3,6.6-6.6v-14.4c0-3.6-3-6.6-6.6-6.6h-1.6 c-3.6,0-6.6,3-6.6,6.6V251.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M186.6,251.1c0,3.6,3,6.6,6.6,6.6h1.6c3.6,0,6.6-3,6.6-6.6v-14.4c0-3.6-3-6.6-6.6-6.6h-1.6 c-3.6,0-6.6,3-6.6,6.6V251.1z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M239.3,275.5C239.3,275.5,239.3,275.5,239.3,275.5c0.4,4.8,0.2,8.1-0.4,10.4l-0.2,0.8 c-0.4,1.7-0.4,1.7-0.8,2.5l-0.2,0.5l0.7,0l0.1-0.2c0.4-0.9,0.4-0.9,0.8-2.6l0.2-0.8c0.6-2.3,0.7-5.7,0.4-10.5H239.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M175.2,275.5C175.2,275.5,175.2,275.5,175.2,275.5c-0.4,4.8-0.2,8.1,0.4,10.4l0.2,0.8 c0.4,1.7,0.4,1.7,0.8,2.5l0.2,0.5l-0.7,0l-0.1-0.2c-0.4-0.9-0.4-0.9-0.8-2.6l-0.2-0.8c-0.6-2.3-0.7-5.7-0.4-10.5H175.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M189.5,168.6c-15.6,10-14.9,29.7-14.8,30c0,0,0,0,0,0l0.7-0.2c0-1.7-0.1-21.4,16.4-30.3l-0.9,0.2 L189.5,168.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M225,168.6c15.6,10,14.9,29.7,14.8,30c0,0,0,0,0,0l-0.7-0.2c0-1.7,0.1-21.4-16.4-30.3l0.9,0.2L225,168.6z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Brazo_Izquierdo_00000148653336567977812490000006334443712870192286_",
    gradientUnits: "userSpaceOnUse",
    x1: 436.807,
    y1: 690.1237,
    x2: 424.6077,
    y2: 721.2172,
    gradientTransform: "matrix(-0.1912 -1.0559 -1.2823 0.1758 1146.218 609.355)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7E1EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1737,
    style: {
      stopColor: "#CED9E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6784,
    style: {
      stopColor: "#B7C5CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AFBEC7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Brazo_Izquierdo_00000152969291385707681600000016922097027802200201_",
    style: {
      fill: "url(#Brazo_Izquierdo_00000148653336567977812490000006334443712870192286_)"
    },
    d: " M176.7,301c-0.8,1.8-1.8,4.7-1.8,4.7c-5-1-10.9-5.5-13.6-7.2c-20.1-12.5-32.1-33.2-23.7-43c1.4-1.6,4.7-4.3,9.5-5.4 c6-1.3,11.2,0.6,12.2,1c8.8,3.3,7.6,9.5,20.3,33.1c1,1.9,2.5,4.6,3.3,7.8c0,0-1.8,1.3-3.4,4C179.4,295.9,178.1,297.9,176.7,301z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104692680634676668970000004135765649720905642_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.7516,
    y1: 358.6733,
    x2: 144.1418,
    y2: 360.1052,
    gradientTransform: "matrix(0.9925 -0.1224 -0.1224 -0.9925 40.7113 645.7455)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3533,
    style: {
      stopColor: "#FCFDFD",
      stopOpacity: 0.6467
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5657,
    style: {
      stopColor: "#F4F6F8",
      stopOpacity: 0.4343
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7409,
    style: {
      stopColor: "#E6E9EF",
      stopOpacity: 0.2591
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8949,
    style: {
      stopColor: "#D2D8E2",
      stopOpacity: 0.1051
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFC8D6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104692680634676668970000004135765649720905642_)"
    },
    d: "M140.2,277.2c2.4-1.8,4.7-3.8,6.6-5.9 c2-2.2,3.5-4.4,4.5-6.6c0.1-0.2,0-0.3-0.2-0.4c-0.2-0.1-0.3,0-0.4,0.2c-1,2.2-2.4,4.3-4.4,6.4c-2,2.1-4.1,4.1-6.6,5.8 c-0.1,0.1-0.2,0.3-0.1,0.4c0.1,0.1,0.2,0.1,0.3,0.1C140.1,277.2,140.2,277.2,140.2,277.2"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000149371546003575966180000005939603980330333850_",
    points: "256.1,283.2 245.7,330.3 230.1,330.7  230.1,333.6 308.9,333.6 321.9,283.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000051374328246225149320000013244519649137688234_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000149371546003575966180000005939603980330333850_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090979944239882727210000014886366807479640450_",
    gradientUnits: "userSpaceOnUse",
    x1: 233.6684,
    y1: 166.5193,
    x2: 326.3875,
    y2: 221.4846,
    gradientTransform: "matrix(1 0 0 -1 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0B0B0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2917,
    style: {
      stopColor: "#0E0E10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4822,
    style: {
      stopColor: "#161618"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6438,
    style: {
      stopColor: "#242527"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7892,
    style: {
      stopColor: "#383A3C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9225,
    style: {
      stopColor: "#525557"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#65696B"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000051374328246225149320000013244519649137688234_)",
      fill: "url(#SVGID_00000090979944239882727210000014886366807479640450_)"
    },
    points: " 225.8,333.2 230.7,275.5 326.1,283.6 321.2,341.3  "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 282.5,
    cy: 308.5,
    r: 6.5
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018930522693603351360000009089246364385640086_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.3558,
    y1: 398.6468,
    x2: 329.9812,
    y2: 212.6873
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5562,
    style: {
      stopColor: "#33958C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8593,
    style: {
      stopColor: "#007B6F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "none",
      fill: "url(#SVGID_00000018930522693603351360000009089246364385640086_)"
    },
    d: "M389.3,383.2v33 c0,6.3,7.2,9.9,12.3,6.1l78.9-59.2c4.1-2.9,4.1-9.1,0-12.1l-78.9-59.2c-5.1-3.8-12.3-0.2-12.3,6.1v35.7h-175 c-57.3,0-104-46.7-104-104c0-18.1,4.7-35.2,12.9-50L80,155.3c-12.2,22-19.2,47.4-19.2,74.3c0,84.7,68.9,153.6,153.6,153.6H389.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091699749573995529630000000806924042368653241_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.73,
    y1: 327.7022,
    x2: 439.5792,
    y2: 250.5626
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    style: {
      stopColor: "#FFAF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    style: {
      stopColor: "#FEAB02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4118,
    style: {
      stopColor: "#FA9F09"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5383,
    style: {
      stopColor: "#F48C14"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6229,
    style: {
      stopColor: "#EE7A1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DE453D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091699749573995529630000000806924042368653241_)"
    },
    d: "M389.3,383.2v33c0,6.3,7.2,9.9,12.3,6.1 l78.9-59.2c4.1-2.9,4.1-9.1,0-12.1l-78.9-59.2c-5.1-3.8-12.3-0.2-12.3,6.1v35.7h-175c-57.3,0-104-46.7-104-104 c0-18.1,4.7-35.2,12.9-50L80,155.3c-12.2,22-19.2,47.4-19.2,74.3c0,84.7,68.9,153.6,153.6,153.6H389.3z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthiqunProgress);
export default __webpack_public_path__ + "static/media/ethiqun-progress.6b39bfc6b50723c2c1067c886b700902.svg";
export { ForwardRef as ReactComponent };